// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../auth/AuthContext";
// import { useSessionStore } from "../../stores/sessionStore";
// import { api } from "../../config/middleware";
// import {
//   API_GETSERVICEWITHPRODUCTS,
//   API_UPDATEBILL,
//   API_GETBILLDETAIL,
// } from "../../config/api";

// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Container,
//   Row,
//   Col,
//   ModalFooter,
//   Label,
//   Table,
// } from "reactstrap";
// import Header from "components/Headers/Header";
// import Swal from "sweetalert2";

// const EditOrderBillOrg = () => {
//   const sa = {
//     info: (text, title = "แจ้งเตือน") =>
//       Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
//     success: (text, title = "สำเร็จ") =>
//       Swal.fire({ icon: "success", title, text, confirmButtonText: "ตกลง" }),
//     error: (text, title = "เกิดข้อผิดพลาด") =>
//       Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
//   };

//   const navigate = useNavigate();
//   const location = useLocation();

//   // ---------- ข้อมูล session / org ----------
//   const { user } = useAuth();
//   const role = (
//     user?.role ||
//     localStorage.getItem("role") ||
//     "user"
//   ).toLowerCase();

//   const orgId = useSessionStore((s) => s.profile?.orgId);
//   const tnId = useSessionStore((s) => s.profile?.tnId);
//   const brId = useSessionStore((s) => s.profile?.brId);

//   // ---------- รับ customer จาก OrderBillOrg ----------
//   const navState = location.state || {};
//   const customerFromState = navState.customer || null;
//   const bNumberFromState = navState.bNumber || null;
//   const fromPath = navState.fromPath || null;

//   const [billDetail, setBillDetail] = useState(null);

//   // helper แปลง ISO -> YYYY-MM-DD สำหรับ input type="date"
//   const toDateInput = (iso) => {
//     if (!iso) return "";
//     const d = new Date(iso);
//     if (isNaN(d.getTime())) return "";
//     const y = d.getFullYear();
//     const m = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     return `${y}-${m}-${day}`;
//   };

//   const customerDisplay = billDetail?.customer
//     ? `(${billDetail.customer.cmCode}) - ${billDetail.customer.cmName}`
//     : customerFromState
//     ? `(${customerFromState.code}) - ${customerFromState.name}`
//     : "";

//   // ---------- form header ----------
//   const [form, setForm] = useState({
//     serviceId: "",
//     customerCode: customerFromState?.code || "",
//   });

//   // วันที่
//   const [receiveDate, setReceiveDate] = useState(""); // BRECEIVE
//   const [dueDate, setDueDate] = useState(""); // BDUEDATE

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     setForm((s) => ({ ...s, [name]: value }));
//   };

//   // ---------- state สำหรับ service + product จาก API ----------
//   const [services, setServices] = useState([]);
//   const [loadingServices, setLoadingServices] = useState(false);
//   const [serviceError, setServiceError] = useState("");

//   const [selectedServiceId, setSelectedServiceId] = useState("");
//   const [productOptions, setProductOptions] = useState([]);

//   // โหลดบริการ + products จาก API_GETSERVICEWITHPRODUCTS (ส่ง ORGID)
//   useEffect(() => {
//     if (!orgId) return;
//     const fetchServices = async () => {
//       setLoadingServices(true);
//       setServiceError("");
//       try {
//         const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
//           params: { ORGID: orgId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         setServices(arr);
//       } catch (e) {
//         console.error("API_GETSERVICEWITHPRODUCTS error:", e);
//         setServiceError(
//           e?.response?.data?.message || e?.message || "ไม่สามารถโหลดบริการได้"
//         );
//       } finally {
//         setLoadingServices(false);
//       }
//     };
//     fetchServices();
//   }, [orgId]);

//   // แปลง service เป็น options สำหรับ select
//   const serviceOptions = useMemo(
//     () =>
//       services.map((s) => ({
//         value: String(s.svId),
//         label: `(${s.svCode}) ${s.svName}`,
//         raw: s,
//       })),
//     [services]
//   );

//   // service ปัจจุบันที่เลือก + หน่วย
//   const currentService = useMemo(
//     () => services.find((s) => String(s.svId) === String(form.serviceId)),
//     [services, form.serviceId]
//   );

//   const currentUnit = currentService?.svUnit || "";
//   // เมื่อเลือกบริการ → set serviceId + productOptions
//   const onServiceChange = (e) => {
//     const value = e.target.value;
//     setSelectedServiceId(value);
//     setForm((s) => ({
//       ...s,
//       serviceId: value,
//     }));

//     const found = services.find((sv) => String(sv.svId) === String(value));
//     if (found && Array.isArray(found.products)) {
//       setProductOptions(found.products); // [{ pdId, pdCode, pdName, pdPrice }, ...]
//     } else {
//       setProductOptions([]);
//     }

//     // เคลียร์ฟอร์มย่อย + ตารางรายการ ทุกครั้งที่เปลี่ยนบริการ
//     setDetailProductId("");
//     setDetailQty("");
//     setDetailPrice("");
//     setDetails([]);
//   };

//   // ---------- ฟิลด์ย่อย: รายการสินค้า ----------
//   const [detailProductId, setDetailProductId] = useState(""); // pdId
//   const [detailQty, setDetailQty] = useState(""); // จำนวน
//   const [detailPrice, setDetailPrice] = useState(""); // ราคา (จาก pdPrice)
//   const [details, setDetails] = useState([]); // รายการทั้งหมด

//   // เมื่อเลือกสินค้า → เติมราคาอัตโนมัติจาก productOptions
//   const handleSelectProduct = (e) => {
//     const val = e.target.value; // pdId
//     setDetailProductId(val);

//     const found = productOptions.find((p) => String(p.pdId) === String(val));
//     if (found) {
//       setDetailPrice(Number(found.pdPrice || 0).toFixed(2));
//     } else {
//       setDetailPrice("");
//     }
//   };

//   // เพิ่มรายการ detail
//   const handleAddDetail = () => {
//     const qty = Number(detailQty);
//     const price = Number(detailPrice);

//     if (!detailProductId) return alert("กรุณาเลือกสินค้า");
//     if (!qty || qty <= 0) return alert("กรุณากรอกจำนวนให้ถูกต้อง");
//     if (!price || price <= 0) return alert("ราคาสินค้าไม่ถูกต้อง");

//     const product = productOptions.find(
//       (p) => String(p.pdId) === String(detailProductId)
//     );

//     setDetails((prev) => [
//       ...prev,
//       {
//         id: Date.now(),
//         pdId: product?.pdId,
//         pdCode: product?.pdCode,
//         productLabel: product?.pdName || "",
//         qty,
//         price,
//       },
//     ]);

//     // เคลียร์ input ย่อย
//     setDetailProductId("");
//     setDetailQty("");
//     setDetailPrice("");
//   };

//   const handleRemoveDetail = (id) => {
//     setDetails((prev) => prev.filter((d) => d.id !== id));
//   };

//   const handleChangeDetailQty = (id, value) => {
//     const qty = Number(value);
//     setDetails((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, qty: isNaN(qty) ? "" : qty } : item
//       )
//     );
//   };

//   const handleCancelAddRecordOrder = () => {
//     // ถ้ามี fromPath และอยู่ในลิสต์ที่อนุญาต → ย้อนกลับไปที่เดิม
//     const allowBack = ["/order-list", "/order-bill-org"];

//     if (fromPath && allowBack.includes(fromPath)) {
//       navigate(fromPath);
//       return;
//     }

//     // ถ้าไม่มี fromPath หรือไม่อยู่ในลิสต์ ใช้ default เดิม
//     navigate("/order-bill-org");
//   };

//   // (ยังไม่ทำ submit จริง เพราะโจทย์เน้นโชว์ข้อมูล + ดึงจาก API)
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("customerFromState:", customerFromState);
//     console.log("serviceId:", form.serviceId);
//     console.log("details:", details);
//     alert("ตัวอย่าง: ดูข้อมูลใน console.log ก่อนเชื่อม API บันทึกจริง");
//   };

//   const handleSaveBill = async () => {
//     try {
//       // ตรวจค่าพื้นฐานก่อน
//       if (tnId == null || orgId == null || brId == null) {
//         await Swal.fire({
//           icon: "error",
//           title: "ไม่พบข้อมูลสาขาหรือองค์กร (TNID/ORGID/BRID)",
//           confirmButtonText: "ปิด",
//         });
//         return;
//       }

//       if (!form.customerCode) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเลือกลูกค้า",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       if (!form.serviceId) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเลือกแพ็คเกจ/บริการ",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       if (!receiveDate || !dueDate) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       if (details.length === 0) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       // แปลง details -> ITEMS ตามโครง API
//       const ITEMS = details
//         .filter((d) => d.pdId)
//         .map((d) => ({
//           pdId: d.pdId,
//           bdQty: Number(d.qty || 0),
//           pdPrice: Number(d.price || 0),
//         }))
//         .filter((it) => it.bdQty > 0);

//       if (ITEMS.length === 0) {
//         await Swal.fire({
//           icon: "info",
//           title: "ไม่พบรายการสินค้าที่สามารถอัปเดตบิลได้",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       const payload = {
//         BNUMBER: bNumberFromState,
//         TNID: tnId,
//         ORGID: orgId,
//         BRID: brId,
//         CMCODE: form.customerCode,
//         SVID: form.serviceId,
//         BRECEIVE: receiveDate,
//         BDUEDATE: dueDate,
//         DISCOUNT: 0,
//         VAT: 0,
//         ITEMS,
//       };

//       const res = await api.post(API_UPDATEBILL, payload);
//       const ok = res?.data?.statustext === "SUCCESS";

//       if (!ok) {
//         console.error("UpdateBill error:", res?.data);
//         await Swal.fire({
//           icon: "error",
//           title: res?.data?.message || "อัปเดตบิลไม่สำเร็จ",
//           confirmButtonText: "ปิด",
//         });
//         return;
//       }

//       // ✅ success (auto close)
//       await Swal.fire({
//         icon: "success",
//         title: res?.data?.message || "อัปเดตบิลสำเร็จ",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       navigate("/order-bill-org");
//     } catch (e) {
//       console.error("UpdateBill exception:", e);

//       await Swal.fire({
//         icon: "error",
//         title: e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด",
//         confirmButtonText: "ปิด",
//       });
//     }
//   };

//   useEffect(() => {
//     if (!orgId || !bNumberFromState) return;

//     const fetchBillDetail = async () => {
//       try {
//         const res = await api.get(API_GETBILLDETAIL, {
//           params: { BNUMBER: bNumberFromState }, // ถ้า backend ต้องการ ORGID/BRID ก็เติมเพิ่มได้
//         });

//         const data = res?.data?.data;
//         if (!data) return;

//         setBillDetail(data);

//         // set header form
//         setForm((s) => ({
//           ...s,
//           serviceId: String(data.svId || ""),
//           customerCode: data.cmCode || "",
//         }));

//         // วันที่รับ / ส่ง
//         setReceiveDate(toDateInput(data.bReceive));
//         setDueDate(toDateInput(data.bDuedate));

//         // รายการ detail
//         const items = Array.isArray(data.items) ? data.items : [];
//         setDetails(
//           items.map((it) => ({
//             id: it.bdId, // ใช้ bdId เป็น key
//             bdId: it.bdId,
//             pdId: it.pdId,
//             pdCode: it.pdCode,
//             productLabel: it.pdName || "",
//             qty: Number(it.qty || 0),
//             price: Number(it.price || 0),
//           }))
//         );
//       } catch (e) {
//         console.error("API_GETBILLDETAIL error:", e);
//         sa.error(
//           e?.response?.data?.message || e?.message || "โหลดข้อมูลบิลไม่สำเร็จ"
//         );
//       }
//     };

//     fetchBillDetail();
//   }, [orgId, bNumberFromState]);

//   // หลัง useEffect โหลด services
//   useEffect(() => {
//     // ต้องมี services ก่อน
//     if (!services.length) return;

//     // svId ที่จะใช้หา service ปัจจุบัน
//     const svId = form.serviceId || billDetail?.svId;
//     if (!svId) return;

//     const found = services.find((s) => String(s.svId) === String(svId));
//     if (found && Array.isArray(found.products)) {
//       setProductOptions(found.products); // เติมสินค้าของ service นี้
//     } else {
//       setProductOptions([]);
//     }
//   }, [services, form.serviceId, billDetail]);

//   return (
//     <>
//       <Header />
//       <Container className="mt--7" fluid>
//         <Row>
//           <Col xs="12">
//             <Card className="bg-secondary shadow">
//               <CardHeader className="bg-white border-0">
//                 <Row className="align-items-center">
//                   <Col xs="8">
//                     <h6 className="mb-0">แก้ไขบิล {bNumberFromState}</h6>
//                   </Col>
//                 </Row>
//               </CardHeader>
//               <CardBody>
//                 <Form onSubmit={handleSubmit}>
//                   <h6 className="heading-small text-muted mb-4">
//                     ข้อมูลส่วนหัว
//                   </h6>
//                   <Row>
//                     {/* ลูกค้า จาก OrderBillOrg */}
//                     <Col lg="6">
//                       <FormGroup>
//                         <label className="form-control-label d-block">
//                           ลูกค้า
//                         </label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           name="customer"
//                           value={customerDisplay}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     {/* บริการ จาก API_GETSERVICEWITHPRODUCTS */}
//                     <Col lg="6">
//                       <FormGroup>
//                         <label className="form-control-label d-block">
//                           แพ็คเกจ
//                         </label>
//                         <Input
//                           id="serviceSelect"
//                           className="form-control-alternative"
//                           type="select"
//                           name="serviceId"
//                           value={form.serviceId}
//                           onChange={onServiceChange}
//                           required
//                           disabled={loadingServices || !!serviceError}
//                         >
//                           <option value="">
//                             {loadingServices
//                               ? "กำลังโหลดบริการ..."
//                               : serviceError || "-- เลือก --"}
//                           </option>
//                           {serviceOptions.map((o) => (
//                             <option key={o.value} value={o.value}>
//                               {o.label}
//                             </option>
//                           ))}
//                         </Input>
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col lg="6">
//                       <FormGroup className="mb-4">
//                         <label className="form-control-label">
//                           วันที่รับผ้า
//                         </label>
//                         <Input
//                           type="date"
//                           className="form-control-alternative"
//                           value={receiveDate}
//                           onChange={(e) => setReceiveDate(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>
//                     <Col lg="6">
//                       <FormGroup className="mb-0">
//                         <label className="form-control-label">
//                           วันที่ส่งผ้า
//                         </label>
//                         <Input
//                           type="date"
//                           className="form-control-alternative"
//                           value={dueDate}
//                           onChange={(e) => setDueDate(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <hr className="my-4" />
//                   <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>

//                   <Row>
//                     {/* สินค้า จาก products ของ service ที่เลือก */}
//                     <Col lg="4">
//                       <FormGroup>
//                         <label className="form-control-label">สินค้า</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="select"
//                           name="detailProductId"
//                           value={detailProductId}
//                           onChange={handleSelectProduct}
//                           disabled={productOptions.length === 0}
//                         >
//                           <option value="">
//                             {productOptions.length === 0
//                               ? "-- เลือกบริการก่อน --"
//                               : "-- เลือก --"}
//                           </option>
//                           {productOptions.map((p) => (
//                             <option key={p.pdId} value={p.pdId}>
//                               {p.pdName}
//                             </option>
//                           ))}
//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     {/* จำนวน */}
//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">จำนวน</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="number"
//                           min="1"
//                           value={detailQty}
//                           onChange={(e) => setDetailQty(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">หน่วย</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           value={currentUnit || ""}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     {/* ค่าบริการ/ชิ้น (จาก pdPrice) */}
//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">
//                           ค่าบริการ/ชิ้น
//                         </label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           value={detailPrice}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     {/* ปุ่มเพิ่ม */}
//                     <Col lg="2">
//                       <FormGroup className="mb-0">
//                         <Label className="invisible">offset</Label>
//                         <Button
//                           color="info"
//                           onClick={handleAddDetail}
//                           className="w-100"
//                           type="button"
//                         >
//                           เพิ่ม
//                         </Button>
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <hr className="my-4" />

//                   {/* ตารางรายการ */}
//                   <Row>
//                     <Col lg="12">
//                       <div className="table-responsive">
//                         <Table
//                           responsive
//                           hover
//                           borderless
//                           className="table table-modern mb-0 order-detail-table"
//                         >
//                           <thead className="thead-dark">
//                             <tr>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "50%" }}
//                               >
//                                 สินค้า
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 จำนวน
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 หน่วย
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 ค่าบริการ/ชิ้น
//                               </th>
//                               <th
//                                 className="text-right"
//                                 style={{ width: "20%" }}
//                               ></th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {details.length === 0 ? (
//                               <tr>
//                                 <td
//                                   colSpan={4}
//                                   className="text-center text-muted"
//                                 >
//                                   ยังไม่มีรายการ
//                                 </td>
//                               </tr>
//                             ) : (
//                               details.map((d) => (
//                                 <tr key={d.id}>
//                                   <td data-th="สินค้า">
//                                     <Input
//                                       type="text"
//                                       value={d.productLabel || ""}
//                                       readOnly
//                                       className="form-control-alternative w-100 text-center"
//                                     />
//                                   </td>
//                                   <td data-th="รหัสสินค้า">
//                                     <Input
//                                       type="number"
//                                       min="0"
//                                       value={d.qty}
//                                       onChange={(e) =>
//                                         handleChangeDetailQty(
//                                           d.id,
//                                           e.target.value
//                                         )
//                                       }
//                                       className="form-control-alternative w-100 text-center"
//                                       style={{
//                                         maxWidth: 120,
//                                         margin: "0 auto",
//                                         textAlign: "center",
//                                       }}
//                                     />
//                                   </td>
//                                   <td data-th="จำนวน">
//                                     <Input
//                                       type="text"
//                                       value={currentUnit || ""}
//                                       readOnly
//                                       className="form-control-alternative w-100 text-center"
//                                     />
//                                   </td>
//                                   <td data-th="ค่าบริการ/ชิ้น">
//                                     <Input
//                                       type="text"
//                                       value={Number(d.price).toFixed(2)}
//                                       readOnly
//                                       disabled
//                                       className="form-control-alternative w-100 text-center"
//                                       style={{
//                                         maxWidth: 140,
//                                         marginLeft: "auto",
//                                       }}
//                                     />
//                                   </td>
//                                   <td className="text-right">
//                                     <Button
//                                       color="danger"
//                                       onClick={() => handleRemoveDetail(d.id)}
//                                       type="button"
//                                     >
//                                       ลบ
//                                     </Button>
//                                   </td>
//                                 </tr>
//                               ))
//                             )}
//                           </tbody>
//                         </Table>
//                       </div>
//                     </Col>
//                   </Row>

//                   {/* ปุ่มบันทึก/ยกเลิก */}
//                   <ModalFooter className="px-0">
//                     <Button
//                       color="secondary"
//                       onClick={handleCancelAddRecordOrder}
//                       type="button"
//                     >
//                       ยกเลิก
//                     </Button>
//                     <Button
//                       color="warning"
//                       type="button"
//                       onClick={handleSaveBill}
//                     >
//                       อัปเดต
//                     </Button>
//                   </ModalFooter>
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </>
//   );
// };

// export default EditOrderBillOrg;

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { useSessionStore } from "../../stores/sessionStore";
import { api } from "../../config/middleware";
import {
  API_GETSERVICEWITHPRODUCTS,
  API_UPDATEBILL,
  API_GETBILLDETAIL,
  API_GETPRODUCTS,
  API_ADDPRODUCT,
} from "../../config/api";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  ModalFooter,
  Label,
  Table,
} from "reactstrap";
import Header from "components/Headers/Header";
import Swal from "sweetalert2";

const EditOrderBillOrg = () => {
  const sa = {
    info: (text, title = "แจ้งเตือน") =>
      Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
    success: (text, title = "สำเร็จ") =>
      Swal.fire({
        icon: "success",
        title,
        text,
        showConfirmButton: false,
        timer: 1500,
      }),
    error: (text, title = "เกิดข้อผิดพลาด") =>
      Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
  };

  const navigate = useNavigate();
  const location = useLocation();

  // ---------- session ----------
  const { user } = useAuth(); // unused
  const orgId = useSessionStore((s) => s.profile?.orgId);
  const tnId = useSessionStore((s) => s.profile?.tnId);
  const brId = useSessionStore((s) => s.profile?.brId);

  // ---------- nav state ----------
  const navState = location.state || {};
  const customerFromState = navState.customer || null;
  const bNumberFromState = navState.bNumber || null;
  const fromPath = navState.fromPath || null;

  // ---------- form header (LOCK) ----------
  const [form, setForm] = useState({
    serviceId: "",
    customerCode: customerFromState?.code || "",
  });

  const [billDetail, setBillDetail] = useState(null);

  const toDateInput = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  // วันที่
  const [receiveDate, setReceiveDate] = useState("");
  const [dueDate, setDueDate] = useState("");

  // ---------- services (ไว้เช็คคงเหลือ/หน่วย) ----------
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);
  const [serviceError, setServiceError] = useState("");

  useEffect(() => {
    if (!orgId) return;
    const fetchServices = async () => {
      setLoadingServices(true);
      setServiceError("");
      try {
        const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        setServices(arr);
      } catch (e) {
        console.error("API_GETSERVICEWITHPRODUCTS error:", e);
        setServiceError(
          e?.response?.data?.message || e?.message || "ไม่สามารถโหลดบริการได้",
        );
      } finally {
        setLoadingServices(false);
      }
    };
    fetchServices();
  }, [orgId]);

  const currentService = useMemo(() => {
    const fromApi = services.find(
      (s) => String(s.svId) === String(form.serviceId),
    );
    return fromApi || null;
  }, [services, form.serviceId]);

  const isPieceBased = currentService?.svType === "รายชิ้น";
  const pkgPrice = Number(currentService?.svPrice || 0);

  const pkgQty = Number(currentService?.svQty || 0);
  const currentUnit = String(currentService?.svUnit || "").trim();

  const isQtyLimitedUnit = useMemo(() => {
    if (isPieceBased) return false; // ✅ รายชิ้น ไม่คุมจำนวน
    return currentUnit === "ชุด" || currentUnit === "ตัว/ชิ้น";
  }, [isPieceBased, currentUnit]);

  const isKgUnit = useMemo(() => {
    if (isPieceBased) return false; // ✅ รายชิ้น ไม่คุมน้ำหนัก
    return currentUnit === "กิโลกรัม";
  }, [isPieceBased, currentUnit]);

  // ---------- products (เหมือน AddRecordOrder) ----------
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);

  const fetchProducts = async () => {
    if (!orgId) return;
    setLoadingProducts(true);
    try {
      const cmcode = (form.customerCode || "").trim();

      // 1) สินค้าลูกค้า
      let res = await api.get(API_GETPRODUCTS, {
        params: { ORGID: orgId, CMCODE: cmcode || "cmcode" },
      });
      let arr = Array.isArray(res?.data?.data) ? res.data.data : [];

      // 2) fallback สินค้าระบบ
      if (!arr || arr.length === 0) {
        res = await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId, CMCODE: "ORG" },
        });
        arr = Array.isArray(res?.data?.data) ? res.data.data : [];
      }

      setProducts(arr);
      return arr;
    } catch (e) {
      console.error("API_GETPRODUCTS error:", e);
      sa.error(
        e?.response?.data?.message || e?.message || "ไม่สามารถโหลดสินค้าได้",
      );
      setProducts([]);
      return [];
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    if (!orgId || !form.customerCode) return;
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, form.customerCode]);

  // ---------- รายการทั้งหมด (api + custom) ----------
  const [details, setDetails] = useState([]);

  const totalQty = useMemo(
    () => details.reduce((sum, d) => sum + Number(d.qty || 0), 0),
    [details],
  );

  const totalWeight = useMemo(() => {
    return details.reduce((sum, d) => {
      const qty = Number(d?.qty ?? 0);
      const w = Number(d?.weight ?? 0);
      const row = (isNaN(qty) ? 0 : qty) * (isNaN(w) ? 0 : w);
      return sum + row;
    }, 0);
  }, [details]);

  const exceedQtyAlert = (nextQty) =>
    sa.info(
      `จำนวนรวม ${nextQty} เกินจำนวนคงเหลือ ${pkgQty} ${currentUnit || ""}`,
    );

  const exceedWeightAlert = (nextWeight) =>
    sa.info(
      `น้ำหนักรวม ${Number(nextWeight || 0).toFixed(2)} เกินจำนวนคงเหลือ ${Number(
        pkgQty || 0,
      ).toFixed(2)} ${currentUnit || ""}`,
    );

  // ---------- ฟอร์มเพิ่มรายการแบบ API ----------
  const [detailProductId, setDetailProductId] = useState("");
  const [detailQty, setDetailQty] = useState("");
  const [detailPrice, setDetailPrice] = useState("");
  const [detailWeight, setDetailWeight] = useState("");

  const handleSelectProduct = (e) => {
    const val = e.target.value;
    setDetailProductId(val);

    const found = products.find((p) => String(p.pdId) === String(val));
    if (found) {
      setDetailPrice(Number(found.pdPrice || 0).toFixed(2));
      setDetailWeight(Number(found.pdWeight || 0).toFixed(2));
    } else {
      setDetailPrice("");
      setDetailWeight("");
    }
  };

  const handleAddDetail = () => {
    const qty = Number(detailQty);
    const price = Number(detailPrice);

    if (!detailProductId) return sa.info("กรุณาเลือกสินค้า");
    if (!qty || qty <= 0) return sa.info("กรุณากรอกจำนวนให้ถูกต้อง");
    if (!price || price <= 0) return sa.info("ราคาสินค้าไม่ถูกต้อง");

    // ✅ คุมจำนวน (ชุด/ตัว-ชิ้น)
    if (isQtyLimitedUnit && currentService) {
      const nextTotalQty = Number(totalQty) + qty;
      if (nextTotalQty > pkgQty) return exceedQtyAlert(nextTotalQty);
    }

    // ✅ คุมน้ำหนัก (กิโลกรัม)
    if (isKgUnit && currentService) {
      const addWeight = Number(detailWeight || 0) * qty;
      const nextTotalWeight = Number(totalWeight) + addWeight;
      if (nextTotalWeight > pkgQty) return exceedWeightAlert(nextTotalWeight);
    }

    const product = products.find(
      (p) => String(p.pdId) === String(detailProductId),
    );

    setDetails((prev) => [
      ...prev,
      {
        id: Date.now(),
        type: "api",
        pdId: product?.pdId,
        pdCode: product?.pdCode,
        productLabel: product?.pdName || "",
        qty,
        price: Number(product?.pdPrice || 0),
        weight: Number(product?.pdWeight || 0),
      },
    ]);

    setDetailProductId("");
    setDetailQty("");
    setDetailPrice("");
    setDetailWeight("");
  };

  // เพิ่มแถวกรอกเอง
  const handleAddCustomRow = () => {
    setDetails((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: "custom",
        productName: "",
        qty: "",
        price: "",
        weight: "",
      },
    ]);
  };

  const handleRemoveRow = (id) => {
    setDetails((prev) => prev.filter((r) => r.id !== id));
  };

  // เปลี่ยนค่าในแถว (เหมือน AddRecordOrder)
  const handleChangeRow = (id, key, value) => {
    if (key === "qty") {
      if (value === "") {
        setDetails((prev) =>
          prev.map((r) => (r.id === id ? { ...r, qty: "" } : r)),
        );
        return;
      }

      const nextQty = Number(value);
      if (isNaN(nextQty) || nextQty < 0) return;

      if (isQtyLimitedUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const oldQty = Number(currentRow?.qty || 0);
        const nextTotalQty = Number(totalQty) - oldQty + nextQty;
        if (nextTotalQty > pkgQty) return exceedQtyAlert(nextTotalQty);
      }

      if (isKgUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const oldQty = Number(currentRow?.qty || 0);
        const rowWeightEach = Number(currentRow?.weight || 0);

        const oldRowTotalW = rowWeightEach * oldQty;
        const newRowTotalW = rowWeightEach * nextQty;

        const nextTotalWeight =
          Number(totalWeight) - oldRowTotalW + newRowTotalW;

        if (nextTotalWeight > pkgQty) return exceedWeightAlert(nextTotalWeight);
      }

      setDetails((prev) =>
        prev.map((r) => (r.id === id ? { ...r, qty: nextQty } : r)),
      );
      return;
    }

    if (key === "weight") {
      const nextW = value === "" ? "" : Number(value);
      if (value !== "" && (isNaN(nextW) || nextW < 0)) return;

      if (isKgUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const rowQty = Number(currentRow?.qty || 0);
        const oldW = Number(currentRow?.weight || 0);

        const oldRowTotalW = oldW * rowQty;
        const newRowTotalW = Number(nextW || 0) * rowQty;

        const nextTotalWeight =
          Number(totalWeight) - oldRowTotalW + newRowTotalW;

        if (nextTotalWeight > pkgQty) return exceedWeightAlert(nextTotalWeight);
      }

      setDetails((prev) =>
        prev.map((r) => (r.id === id ? { ...r, weight: value } : r)),
      );
      return;
    }

    setDetails((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [key]: value } : r)),
    );
  };

  // ---------- โหลดบิลเดิม ----------
  useEffect(() => {
    if (!orgId || !bNumberFromState) return;

    const fetchBillDetail = async () => {
      try {
        const res = await api.get(API_GETBILLDETAIL, {
          params: { BNUMBER: bNumberFromState },
        });

        const data = res?.data?.data;
        if (!data) return;

        setBillDetail(data);

        setForm((s) => ({
          ...s,
          serviceId: String(data.svId || ""),
          customerCode: data.cmCode || s.customerCode || "",
        }));

        setReceiveDate(toDateInput(data.bReceive));
        setDueDate(toDateInput(data.bDuedate));

        const items = Array.isArray(data.items) ? data.items : [];
        setDetails(
          items.map((it) => ({
            id: it.bdId || `${it.pdId}-${Math.random()}`,
            bdId: it.bdId,
            type: "api",
            pdId: it.pdId,
            pdCode: it.pdCode,
            productLabel: it.pdName || "",
            qty: Number(it.qty || 0),
            price: Number(it.price || 0),
            weight: Number(it.pdWeight || it.weight || 0),
          })),
        );
      } catch (e) {
        console.error("API_GETBILLDETAIL error:", e);
        sa.error(
          e?.response?.data?.message || e?.message || "โหลดข้อมูลบิลไม่สำเร็จ",
        );
      }
    };

    fetchBillDetail();
  }, [orgId, bNumberFromState]);

  // ---------- SAVE (เหมือน AddRecordOrder แต่เป็น UPDATE) ----------
  const handleSaveBill = async () => {
    const normalize = (v) => String(v ?? "").trim();

    const isRealSuccess = (resOrData) => {
      const data = resOrData?.data ? resOrData.data : resOrData;
      const st = normalize(data?.statustext ?? data?.statusText).toUpperCase();
      const msg = normalize(data?.message);
      if (st.includes("SUCCESS")) return true;
      if (msg.includes("บันทึกสำเร็จ") || msg.includes("สำเร็จ")) return true;
      return false;
    };

    try {
      if (tnId == null || orgId == null || brId == null) {
        return sa.error("ไม่พบข้อมูลสาขาหรือองค์กร (TNID/ORGID/BRID)");
      }
      if (!bNumberFromState) return sa.error("ไม่พบเลขที่บิล (BNUMBER)");
      if (!form.customerCode) return sa.info("กรุณาเลือกลูกค้า");
      if (!form.serviceId) return sa.info("กรุณาเลือกแพ็คเกจ/บริการ");
      if (!receiveDate || !dueDate)
        return sa.info("กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า");

      const apiRows = (details || []).filter((d) => !!d?.pdId);
      const customRows = (details || []).filter((d) => {
        const name = String(d?.productName || d?.productLabel || "").trim();
        return !d?.pdId && name.length > 0;
      });

      if (apiRows.length === 0 && customRows.length === 0) {
        return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");
      }

      for (const r of customRows) {
        const name = String(r?.productName || r?.productLabel || "").trim();
        const qty = Number(r?.qty || 0);
        const price = Number(r?.price || 0);
        const weight = Number(r?.weight || 0);

        if (!name) return sa.info("กรุณากรอกชื่อสินค้า (กรอกเอง)");
        if (!qty || qty <= 0)
          return sa.info(`กรุณากรอกจำนวนให้ถูกต้อง (${name})`);
        if (!price || price <= 0)
          return sa.info(`กรุณากรอกราคาให้ถูกต้อง (${name})`);
        if (weight < 0) return sa.info(`กรุณากรอกน้ำหนักให้ถูกต้อง (${name})`);
      }

      // เช็คคงเหลือเหมือนเดิม
      const totalQtyUsed =
        apiRows.reduce((s, d) => s + Number(d.qty || 0), 0) +
        customRows.reduce((s, d) => s + Number(d.qty || 0), 0);

      const totalWeightUsed =
        apiRows.reduce(
          (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
          0,
        ) +
        customRows.reduce(
          (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
          0,
        );

      if (currentService) {
        const unit = String(currentService?.svUnit || "").trim();
        const remain = Number(currentService?.svQty || 0);

        if ((unit === "ชุด" || unit === "ตัว/ชิ้น") && remain > 0) {
          if (totalQtyUsed > remain)
            return sa.info(`จำนวนเกินคงเหลือ (${remain} ${unit})`);
        }
        if (unit === "กิโลกรัม" && remain > 0) {
          if (totalWeightUsed > remain) {
            return sa.info(
              `น้ำหนักรวมเกินคงเหลือ (${remain.toFixed(2)} ${unit})`,
            );
          }
        }
      }

      // 1) เพิ่มสินค้า (กรอกเอง) ก่อน
      const createdCustomByName = [];
      for (const r of customRows) {
        const NAME = String(r?.productName || r?.productLabel || "").trim();
        const PRICE = Number(r?.price || 0);
        const WEIGHT = Number(r?.weight || 0);

        const addRes = await api.post(API_ADDPRODUCT, {
          ORGID: orgId,
          CMCODE: form.customerCode,
          NAME,
          PRICE,
          WEIGHT,
        });

        if (!isRealSuccess(addRes)) {
          console.error("API_ADDPRODUCT not success:", addRes?.data);
          return sa.error(
            addRes?.data?.message || "เพิ่มสินค้ากรอกเองไม่สำเร็จ",
          );
        }

        createdCustomByName.push({
          name: NAME,
          qty: Number(r?.qty || 0),
          price: PRICE,
          weight: WEIGHT,
        });
      }

      // 2) รีเฟรช GETPRODUCTS แล้ว map หา pdId
      const latest = await fetchProducts();

      const apiItems = apiRows
        .map((d) => ({
          pdId: d.pdId,
          bdQty: Number(d.qty || 0),
          pdPrice: Number(d.price || 0),
          weight: Number(d.weight || 0),
        }))
        .filter((it) => it.pdId && it.bdQty > 0);

      const customItems = createdCustomByName
        .map((c) => {
          const found = (latest || []).find(
            (p) =>
              normalize(p?.pdName).toLowerCase() ===
              normalize(c.name).toLowerCase(),
          );
          return {
            pdId: found?.pdId,
            bdQty: Number(c.qty || 0),
            pdPrice: Number(c.price || 0),
            weight: Number(c.weight || 0),
            _name: c.name,
          };
        })
        .filter((it) => it.pdId && it.bdQty > 0);

      const notFoundNames = createdCustomByName
        .filter((c) => {
          const ok = (latest || []).some(
            (p) =>
              normalize(p?.pdName).toLowerCase() ===
              normalize(c.name).toLowerCase(),
          );
          return !ok;
        })
        .map((x) => x.name);

      if (notFoundNames.length > 0) {
        console.error("Custom product not found:", notFoundNames);
        return sa.error(
          `เพิ่มสินค้าแล้ว แต่หา pdId ไม่เจอจากรายการสินค้า: ${notFoundNames.join(", ")}`,
        );
      }

      const ITEMS = [...apiItems, ...customItems].map(
        ({ weight, _name, ...rest }) => rest,
      );

      if (ITEMS.length === 0)
        return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");

      const totalPdWeight = [...apiItems, ...customItems].reduce(
        (sum, d) => sum + Number(d.weight || 0) * Number(d.bdQty || 0),
        0,
      );

      // 3) UPDATE BILL
      const payload = {
        BNUMBER: bNumberFromState,
        TNID: tnId,
        ORGID: orgId,
        BRID: brId,
        CMCODE: form.customerCode,
        SVID: Number(form.serviceId),
        BRECEIVE: receiveDate,
        BDUEDATE: dueDate,
        DISCOUNT: 0,
        VAT: 0,
        TOTALPDWEIGHT: Number(totalPdWeight || 0).toFixed(2),
        ITEMS,
      };

      console.log("ABOUT TO UPDATEBILL payload:", payload);

      const res = await api.post(API_UPDATEBILL, payload);
      if (!isRealSuccess(res)) {
        console.error("API_UPDATEBILL error:", res?.data);
        return sa.error(res?.data?.message || "อัปเดตบิลไม่สำเร็จ");
      }

      await sa.success(res?.data?.message || "อัปเดตบิลสำเร็จ");
      navigate("/order-bill-org");
    } catch (e) {
      console.error("handleSaveBill exception:", e);
      const data = e?.response?.data;
      sa.error(data?.message || e?.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleCancel = () => {
    const allowBack = ["/order-list", "/order-bill-org"];
    if (fromPath && allowBack.includes(fromPath)) return navigate(fromPath);
    navigate("/order-bill-org");
  };

  const customerDisplay = billDetail?.customer
    ? `(${billDetail.customer.cmCode}) - ${billDetail.customer.cmName}`
    : customerFromState
      ? `(${customerFromState.code}) - ${customerFromState.name}`
      : "";

  const serviceDisplay = useMemo(() => {
    const sv = services.find((s) => String(s.svId) === String(form.serviceId));
    if (!sv) return "";
    return `${sv.svCode ? `(${sv.svCode}) ` : ""}${sv.svName || ""}`;
  }, [services, form.serviceId]);

  // ---------- responsive ----------
  const [isSmall, setIsSmall] = useState(window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsSmall(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      <style>{`
  /* ===== DESKTOP/TABLET (default) ===== */
  .zi-table-wrap{
    background:#fff;
    border-radius:10px;
    border:1px solid rgba(0,0,0,.06);
    overflow:hidden;
  }
  .zi-table{ margin:0; width:100%; }
  .zi-table thead th{
    background:#f7fafc;
    color:#0f172a;
    font-weight:700;
    font-size:14px;
    border-bottom:1px solid rgba(0,0,0,.06);
    padding:14px 16px;
    white-space:nowrap;
  }
  .zi-table tbody td{
    padding:14px 16px;
    border-top:1px solid rgba(0,0,0,.06);
    vertical-align:middle;
    font-size:14px;
    color:#0f172a;
  }
  .zi-table tbody tr:hover{ background:#f9fbff; }
  .fw-600{ font-weight:600; }

  /* =========================
     ✅ MOBILE ONLY: table -> card
  ========================== */
  @media (max-width: 767.98px){

    .zi-table-wrap{ overflow: visible; }

    .zi-table{
      border-collapse: separate;
      border-spacing: 0 10px;
      margin: 0;
    }

    .zi-table thead{ display:none; }

    .zi-table tbody tr{
      display:block;
      background:#fff;
      border:1px solid rgba(0,0,0,.06);
      border-radius:12px;
      overflow:hidden;
      box-shadow: 0 1px 2px rgba(15,23,42,.06);
    }

    .zi-table tbody td{
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:12px;
      padding:12px 14px;
      border-top:1px dashed rgba(15,23,42,.10);
      background: transparent;
      text-align:right;
    }

    .zi-table tbody td:first-child{ border-top:none; }

    /* ✅ label (data-th) ชิดซ้าย */
    .zi-table tbody td[data-th]::before{
      content: attr(data-th);
      flex: 0 0 45%;
      max-width: 45%;
      color:#0f172a;
      font-weight:700;
      font-size:13px;
      text-align:left;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }

    /* input/value ชิดขวา */
    .zi-table tbody td .form-control-alternative,
    .zi-table tbody td input{
      flex: 1 1 auto;
      width: 100%;
      max-width: 55%;
      text-align: right;
      border-radius: 10px;
    }

    /* ปุ่มลบ: ไม่มี label และชิดขวาสุด */
    .zi-table tbody td.text-end{
      justify-content:flex-end;
      border-top: 0;
      padding-top: 10px;
      padding-bottom: 12px;
    }
    .zi-table tbody td.text-end::before{
      content:"";
      display:none;
    }

    .zi-table tbody td .btn{
      border-radius:10px;
      padding:8px 12px;
    }
  }
`}</style>

      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xs="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h6 className="mb-0">แก้ไขบิล {bNumberFromState}</h6>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                <Form onSubmit={(e) => e.preventDefault()}>
                  <h6 className="heading-small text-muted mb-4">
                    ข้อมูลส่วนหัว
                  </h6>

                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label d-block">
                          ลูกค้า
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={customerDisplay}
                          readOnly
                          disabled // ✅ lock
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label d-block">
                          แพ็คเกจ
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={
                            loadingServices
                              ? "กำลังโหลดแพ็คเกจ..."
                              : serviceDisplay
                          }
                          readOnly
                          disabled // ✅ lock
                        />
                        {!!serviceError && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: 12 }}
                          >
                            {serviceError}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="6" md="6">
                      <FormGroup className="mb-0">
                        <label className="form-control-label">
                          วันที่รับผ้า
                        </label>
                        <Input
                          type="date"
                          className="form-control-alternative"
                          value={receiveDate}
                          onChange={(e) => setReceiveDate(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6">
                      <FormGroup className="mb-0">
                        <label className="form-control-label">
                          วันที่ส่งผ้า
                        </label>
                        <Input
                          type="date"
                          className="form-control-alternative"
                          value={dueDate}
                          onChange={(e) => setDueDate(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr className="my-4" />
                  <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>

                  {/* ฟอร์มเพิ่มรายการแบบ API */}
                  <Row>
                    <Col lg="3">
                      <FormGroup>
                        <label className="form-control-label">สินค้า</label>
                        <Input
                          className="form-control-alternative"
                          type="select"
                          value={detailProductId}
                          onChange={handleSelectProduct}
                          disabled={loadingProducts || products.length === 0}
                        >
                          <option value="">
                            {loadingProducts
                              ? "-- กำลังโหลดสินค้า --"
                              : products.length === 0
                                ? "-- ไม่มีสินค้า --"
                                : "-- เลือก --"}
                          </option>
                          {products.map((p) => (
                            <option key={p.pdId} value={p.pdId}>
                              ({p.pdCode}) {p.pdName}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="3">
                      <FormGroup>
                        <label className="form-control-label">จำนวนผ้า</label>
                        <Input
                          className="form-control-alternative"
                          type="number"
                          min="1"
                          value={detailQty}
                          onChange={(e) => setDetailQty(e.target.value)}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup>
                        <label className="form-control-label">
                          ค่าบริการต่อชิ้น (บาท)
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={detailPrice}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup>
                        <label className="form-control-label">
                          น้ำหนักต่อชิ้น (กิโลกรัม)
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={detailWeight}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup className="mb-0">
                        <Label className="invisible">offset</Label>
                        <Button
                          color="info"
                          onClick={handleAddDetail}
                          className="w-100"
                          type="button"
                        >
                          เพิ่ม
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr className="my-4" />

                  {/* ปุ่มเพิ่มแถวกรอกเอง */}
                  {/* <div className="d-flex justify-content-end align-items-center mb-2">
                    <Button
                      color="info"
                      type="button"
                      onClick={handleAddCustomRow}
                    >
                      + เพิ่มสินค้า (กรอกเอง)
                    </Button>
                  </div> */}

                  {/* ตารางรายการ */}
                  <Row>
                    <Col lg="12">
                      {isSmall ? (
                        <div className="table-responsive zi-table-wrap">
                          <Table responsive hover className="zi-table mb-0">
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "30%" }}
                                >
                                  สินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  จำนวนผ้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  ค่าบริการต่อชิ้น (บาท)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักรวม (กิโลกรัม)
                                </th>
                                <th
                                  className="text-end"
                                  style={{ width: "10%" }}
                                />
                              </tr>
                            </thead>
                            <tbody>
                              {details.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="text-center text-muted py-4"
                                  >
                                    ยังไม่มีรายการ
                                  </td>
                                </tr>
                              ) : (
                                details.map((d) => {
                                  const rowTotalWeight =
                                    Number(d.weight || 0) * Number(d.qty || 0);

                                  return (
                                    <tr key={d.id}>
                                      <td data-th="สินค้า">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="text"
                                            placeholder="เช่น เสื้อยืด / กางเกง / ผ้าห่ม"
                                            value={d.productName || ""}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "productName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          d.productLabel || ""
                                        )}
                                      </td>
                                      <td data-th="จำนวนผ้า">
                                        <Input
                                          className="form-control-alternative"
                                          type="number"
                                          min="0"
                                          value={d.qty}
                                          onChange={(e) =>
                                            handleChangeRow(
                                              d.id,
                                              "qty",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                      <td data-th="ค่าบริการต่อชิ้น (บาท)">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.price}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "price",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          Number(d.price || 0).toFixed(2)
                                        )}
                                      </td>
                                      <td data-th="น้ำหนักต่อชิ้น (กิโลกรัม)">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.weight}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "weight",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          Number(d.weight || 0).toFixed(2)
                                        )}
                                      </td>
                                      <td data-th="น้ำหนักรวม (กิโลกรัม)">
                                        {Number(rowTotalWeight || 0).toFixed(2)}
                                      </td>
                                      <td className="text-end">
                                        <Button
                                          color="danger"
                                          size="sm"
                                          onClick={() => handleRemoveRow(d.id)}
                                          type="button"
                                        >
                                          ลบ
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="zi-table-wrap">
                          <Table responsive hover className="zi-table mb-0">
                            <thead>
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "30%" }}
                                >
                                  สินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  จำนวนผ้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  ค่าบริการต่อชิ้น (บาท)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักรวม (กิโลกรัม)
                                </th>
                                <th
                                  className="text-end"
                                  style={{ width: "10%" }}
                                />
                              </tr>
                            </thead>
                            <tbody>
                              {details.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="text-center text-muted py-4"
                                  >
                                    ยังไม่มีรายการ
                                  </td>
                                </tr>
                              ) : (
                                details.map((d) => {
                                  const rowTotalWeight =
                                    Number(d.weight || 0) * Number(d.qty || 0);

                                  return (
                                    <tr key={d.id}>
                                      <td>
                                        {d.type === "custom" ? (
                                          <Input
                                            type="text"
                                            placeholder="เช่น เสื้อยืด / กางเกง / ผ้าห่ม"
                                            value={d.productName || ""}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "productName",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={d.productLabel || ""}
                                            readOnly
                                            className="form-control-alternative"
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <Input
                                          type="number"
                                          min="0"
                                          value={d.qty}
                                          onChange={(e) =>
                                            handleChangeRow(
                                              d.id,
                                              "qty",
                                              e.target.value,
                                            )
                                          }
                                          className="form-control-alternative"
                                          style={{
                                            maxWidth: 140,
                                            margin: "0 auto",
                                            textAlign: "center",
                                          }}
                                        />
                                      </td>

                                      <td className="text-center">
                                        {d.type === "custom" ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.price}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "price",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={Number(d.price || 0).toFixed(
                                              2,
                                            )}
                                            readOnly
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {d.type === "custom" ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.weight}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "weight",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={Number(
                                              d.weight || 0,
                                            ).toFixed(2)}
                                            readOnly
                                            disabled
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <Input
                                          type="text"
                                          value={Number(
                                            rowTotalWeight || 0,
                                          ).toFixed(2)}
                                          readOnly
                                          disabled
                                          className="form-control-alternative"
                                          style={{
                                            maxWidth: 140,
                                            margin: "0 auto",
                                            textAlign: "center",
                                          }}
                                        />
                                      </td>

                                      <td className="text-end">
                                        <Button
                                          color="danger"
                                          onClick={() => handleRemoveRow(d.id)}
                                          type="button"
                                        >
                                          ลบ
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/* Summary */}
                  <Row className="justify-content-end mt-3 mb-2">
                    <Col lg="4" md="6" className="text-right">
                      {currentService &&
                        (isPieceBased ? (
                          // ✅ svType === "รายชิ้น"
                          <div
                            style={{
                              background: "#f5f7fa",
                              padding: "12px 15px",
                              borderRadius: "8px",
                              border: "1px solid #e3e6ef",
                            }}
                          >
                            <div style={{ fontSize: 14, color: "#555" }}>
                              น้ำหนักรวมทั้งหมด (กิโลกรัม)
                            </div>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: "#1f2937",
                                marginBottom: 6,
                              }}
                            >
                              {totalWeight.toFixed(2)} กิโลกรัม
                            </div>
                            <div
                              style={{
                                paddingTop: 8,
                                marginTop: 6,
                                fontSize: 14,
                                color: "#0f172a",
                              }}
                            />
                          </div>
                        ) : (
                          // ✅ นอกนั้น (ไม่ใช่ "รายชิ้น")
                          <div
                            style={{
                              background: "#f5f7fa",
                              padding: "12px 15px",
                              borderRadius: "8px",
                              border: "1px solid #e3e6ef",
                            }}
                          >
                            <div
                              style={{
                                paddingTop: 8,
                                fontSize: 14,
                                color: "#0f172a",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <span>น้ำหนักรวมทั้งหมด (กิโลกรัม)</span>
                                <span style={{ fontWeight: 600 }}>
                                  {totalWeight.toFixed(2)} กิโลกรัม
                                </span>
                              </div>

                              <div className="d-flex justify-content-between mt-1">
                                <span>จำนวนคงเหลือ</span>
                                <span style={{ fontWeight: 600 }}>
                                  {pkgQty.toLocaleString()} {currentUnit}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                    </Col>
                  </Row>

                  {/* ปุ่ม */}
                  <ModalFooter className="px-0">
                    <Button
                      color="secondary"
                      onClick={handleCancel}
                      type="button"
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      color="warning"
                      type="button"
                      onClick={handleSaveBill}
                    >
                      อัปเดต
                    </Button>
                  </ModalFooter>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditOrderBillOrg;
